export const completionToastDisplayTime = 5000; // ms
export const validationToastDisplayTime = 10000;
